import { render, staticRenderFns } from "./Inclusive.vue?vue&type=template&id=1ba64b14&scoped=true"
import script from "./Inclusive.vue?vue&type=script&lang=js"
export * from "./Inclusive.vue?vue&type=script&lang=js"
import style0 from "./Inclusive.vue?vue&type=style&index=0&id=1ba64b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba64b14",
  null
  
)

export default component.exports